<h1 class="chart-title" *ngIf="options.titlePosition == 'top' && title">
  {{title}}</h1>
<!-- box-sizing inline: chart.scss sets it too, but consumers that import only the module
     (e.g. the chat app) never load that file — without border-box the 10px paddings ADD to
     the 100% width and the chart overflows its host by 20px on the right. -->
<div *ngIf="chartConfig" [style.width]="'100%'" [style.box-sizing]="'border-box'" [style.height.px]="height - 60" #container class="chart-container"
     [style.padding-left.px]="options.xPadding" [style.padding-top.px]="options.yPadding"
     [style.padding-right.px]="options.xPadding"
     [style.padding-bottom.px]="options.yPadding">
  <svg height="100%" width="100%" #svg xmlns:svg="http://www.w3.org/2000/svg">
    <svg:g *ngIf="(type === 'bar' || type === 'column')" cs-bar-chart [config]="chartConfig"></svg:g>
    <svg:g *ngIf="(type === 'pie' || type === 'donut')" cs-pie-chart [config]="chartConfig"></svg:g>
    <svg:g *ngIf="(type === 'line' || type === 'area')" cs-line-chart [config]="chartConfig"></svg:g>
    <svg:g *ngIf="type === 'waterfall'" cs-waterfall-chart [config]="chartConfig"></svg:g>
    <svg:g *ngIf="type === 'treemap'" cs-treemap-chart [config]="chartConfig"></svg:g>
    <svg:g *ngIf="type === 'funnel'" cs-funnel-chart [config]="chartConfig"></svg:g>
    <svg:g *ngIf="(type === 'scatter' || type === 'bubble')" cs-scatter-chart [config]="chartConfig"></svg:g>
    <svg:g *ngIf="type === 'gauge'" cs-gauge-chart [config]="chartConfig"></svg:g>
    <svg:g *ngIf="type === 'decomposition'" cs-decomposition-chart [config]="chartConfig"></svg:g>

  </svg>
</div>
<h1 class="chart-title" *ngIf="options.titlePosition == 'bottom' && title">{{title}}</h1>
